import io from 'socket.io-client';

const CONNECTION_CONFIG = {
    "reconnectionAttempts": "Infinity",
    "timeout": 10000,
    "transports": ["websocket"],
    "autoConnect": false
}

export const SOCKET_CLIENT = io(process.env.REACT_APP_SOCKET_URL, CONNECTION_CONFIG);

export const authenticateSocket = (token) => {
    if (token) {
        SOCKET_CLIENT.auth = { token };
        SOCKET_CLIENT.io.opts.query = { token }; // Fallback for some versions
        if (!SOCKET_CLIENT.connected) {
            SOCKET_CLIENT.connect();
        }
    }
};



export const sendNotification = (notificationData) => {
    SOCKET_CLIENT.emit('notificationSend', notificationData, (error) => {
        if (error) {
            console.log("*****Socket connection error on notificationSend", error);
        }
    })
}